import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-transparent-logo';
export var ID = 'icon-transparent-logo';
/* eslint-disable max-len */

export var SVGTransparentLogo = function SVGTransparentLogo() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 60 60"
  }, React.createElement("defs", null, React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "70.7106781%",
    id: "radialGradientTransparentLogo"
  }, React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#FBF8F8",
    offset: "100%"
  }))), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("rect", {
    fill: "url(#radialGradientTransparentLogo)",
    x: "0",
    y: "0",
    rx: "2"
  }), React.createElement("path", {
    d: "M32.1095792,18.1151 C32.3805792,18.5911 32.6905792,19.0731 33.0305792,19.5611 C35.1305792,22.5101 38.4605792,24.6151 43.4665792,25.7071 C49.5465792,27.0321 55.3375792,28.0201 60.0005792,32.8921 L60.0005792,26.4191 C57.9795792,20.6381 53.2785792,13.6851 44.2015792,12.3171 C41.5895792,11.9201 39.4695792,11.9281 37.6515792,11.6791 C35.4025792,11.5111 31.1495792,10.9391 29.9205792,9.0001 C29.9205792,9.0001 29.8915792,9.1721 29.8715792,9.4911 C29.8235792,10.2041 29.8195792,11.6311 30.2535792,13.4691 C30.6665792,15.0221 31.2625792,16.6091 32.1095792,18.1151",
    fill: "#CFDEB6"
  }), React.createElement("path", {
    d: "M57.9999756,59.9999939 C59.1039756,59.9999939 59.9999756,59.1039939 59.9999756,57.9999939 L59.9999756,37.5489939 C55.4069756,32.5419939 48.8099756,29.3999939 41.4749756,29.3999939 C27.6049756,29.3999939 16.3499756,40.6499939 16.3499756,54.5279939 C16.3499756,56.4079939 16.5629756,58.2379939 16.9549756,59.9999939 L57.9999756,59.9999939 Z",
    fill: "#FFD5BB"
  }))));
};
/* eslint-disable max-len */

var TransparentLogo = function TransparentLogo(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGTransparentLogo
  });
};

TransparentLogo.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default TransparentLogo;